import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Set before tracking so restoring a Turbo snapshot cannot count twice.
    if (this.element.dataset.tracked) return;
    this.element.dataset.tracked = "true";
    window.plausible?.("SOC2 Guide Newsletter Accepted");
  }
}
